let oranges = [
	'#ef065a',
	'#f12157',
	'#f43055',
	'#f63c53',
	'#f74751',
	'#f9514f',
	'#fa5a4e',
	'#fb634d',
	'#fc6b4c',
	'#fd734b',
	'#fd7b4b',
	'#fd824b',
	'#fe8a4c',
	'#fe914d',
	'#fe984e',
	'#fe9f50',
	'#fda653',
	'#fdad56',
	'#fdb359',
	'#fcba5d',
	'#fcc061',
	'#fbc766',
	'#fbcd6b',
	'#fad370'
];

let differ = [
	'#d41062',
	'#c21362',
	'#5c0f61',
	'#ff7441',
	'#f34f58',
	'#ff2f56',
	'#eb1960',
	'#57103c',
	'#98390b',
	'#6d0e52',
	'#a61649'
];

let tt = [
	'#0b9bdd',
	'#0ca5e3',
	'#12b4f6',
	'#6dd4ff',
	'#b12423',
	'#0b9bdd',
	'#0ca5e3',
	'#12b4f6',
	'#6dd4ff',
	'#b12423',
	'#0b9bdd',
	'#0ca5e3',
	'#12b4f6',
	'#6dd4ff',
	'#b12423',
	'#0b9bdd',
	'#0ca5e3',
	'#12b4f6',
	'#6dd4ff',
	'#b12423',
	'#e8afae',
	'#ffb035',
	'#ea4489',
	'#ffffff',
	'#51d2ad',
	'#c5a868'
];

let greenBlues = [
	'#0281f7',
	'#0096e3',
	'#00a4d7',
	'#00afd2',
	'#00bbcc',
	'#00c8c2',
	'#00d6b0',
	'#0281f7',
	'#0096e3',
	'#00a4d7',
	'#00afd2',
	'#00bbcc',
	'#00c8c2',
	'#00d6b0',
	'#00e690',

	'#e302f7',
	'#d700f4',
	'#ca00f1',
	'#bd00ee'
];

let graduated = [
	'#3a4cc0',
	'#5370dd',
	'#6f91f2',
	'#8daffd',
	'#aac6fd',
	'#c5d5f2',
	'#dddcdb',
	'#efcebc',
	'#f6b79c',
	'#f39879',
	'#e6745a',
	'#d1493e',
	'#ff0000',
	'#ff1500',
	'#ff2a00',
	'#ff4000',
	'#ff5500',
	'#ff6900',
	'#ff8000',
	'#ff9500',
	'#ffaa00',
	'#ffc000',
	'#ffd500',
	'#ffea00',
	'#ffff00'
];

//Primary like:

export default {
	oranges: oranges,

	greys: ['#ffffff', '#efefef', '#dfdfdf', '#cfcfcf', '#c0c0c0', '#b0b0b0', '#a1a1a1', '#939393', '#848484', '#767676'],

	blues: ['#dbf5ff', '#b1deea', '#85c8d3', '#55b3b9', '#059d9d', '#ffffff', '#ffffff'],

	purpleBlue: ['#e90cb9', '#b030b2', '#7755ab', '#3e79a4', '#059d9d'],

	greenBlues: greenBlues,

	graduated: graduated,

	dynamicSets: {
		m4g: oranges,
		tt: tt,
		halftone: differ,
		differ: differ
	},

	getRandomColour(set: any) {
		return set[Math.floor(Math.random() * (set.length - 0.01))];
	}
};
